const gssp = (context) => {
  const { query: { lpc } } = context;
  return { lpc };
};

export default gssp;
